import hasHealthSubscription from "./hasHealthSubscription";
import getMemberTypeCode from "./getMemberTypeCode";
import store from '../Redux/Store'
import {MemberTypeEnum} from "../Config/enums";

const formatCategories = (categories) => {
	const contrats = store.getState().auth?.user?.contractTypes
	// const contrats = store.getState().AuthReducer.user?.contractTypes
	const memberType = getMemberTypeCode(store.getState().auth?.user?.memberType)
	if (!hasHealthSubscription(contrats)) {
		categories = categories.filter((category) => {
			if (category.parentId) {
				return true //On retourne toutes les sous-catégories
			}
			if (category.name === "Facture" || category.name === "Devis" || category.name === "Garantie") {
				return false
			}
			if (category.name?.toLowerCase().includes("compte")) { //Décompte
				return false
			}
			return true
		})
	}
	if (memberType === MemberTypeEnum.MEMBER_TYPE_AFFILIATE) {
		categories = categories.filter((item) => item.name !== "Contrat")
	}
	return categories
}

export default formatCategories
